import React, { useState } from "react"
import { BreakdownWindow } from "../../theming/breakdown-window"
import { ThemedButton } from "../../inputs/buttons/ThemedButton";
import { AdventureActions } from "../../../store/stores/adventures/AdventureStore.Actions";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../store/configureStore";
import { ValidationResultsComponent } from "../../inputs/validation/ValidationResults";
import { Loader } from "../../theming/loader/Loader";


export const AdventureCreator = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { adventures, creating } = useAppSelector(app => app.adventure);
    const currentAdventureNames = adventures.map(a => a.name);
    const [name, setName] = useState("");

    const nameInvalid = currentAdventureNames.any(adventureName => adventureName == name);

    const postCreateCallback = (id: string) => navigate(`/Adventures/${id}/View`);

    const create = () => {
        if (nameInvalid) {
            return;
        }
        dispatch(AdventureActions.createAdventure({name}, postCreateCallback));
    }
    return (
        <BreakdownWindow close={() => navigate("/Adventures")} heading={<h1>Create Adventure</h1>}>
            <div className="form-field">
                <label>Name:</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                <ValidationResultsComponent validationResults={[{match: nameInvalid, message: "An adventure with that name already exists."}]} />
            </div>
            {creating && <Loader>Creating Adventure</Loader>}
            <ThemedButton disabled={nameInvalid} onClick={create}>Create</ThemedButton>
        </BreakdownWindow>
    )
}